(function () {
  if (typeof window === 'undefined') return;

  var SECTION_SELECTOR = '.journey__crew';
  var SETTINGS = {
    maxSize: 100,
    animationSpeed: 5,
    startOpacity: 0.4,
    strokeBase: [120, 160, 200]
  };

  function supportsHover() {
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(section) {
    if (!supportsHover() || prefersReducedMotion()) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'journey__crew-ripple';
    canvas.setAttribute('aria-hidden', 'true');
    section.prepend(canvas);

    var ctx = canvas.getContext('2d');
    var ripples = [];
    var rafId = null;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var sr = SETTINGS.strokeBase;

    function resize() {
      var rect = section.getBoundingClientRect();
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function addRipple(x, y) {
      var lifeFrames = (SETTINGS.maxSize - 2) / SETTINGS.animationSpeed;
      ripples.unshift({
        x: x,
        y: y,
        r: 2,
        opacity: SETTINGS.startOpacity,
        step: SETTINGS.startOpacity / lifeFrames
      });
    }

    function loop() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = ripples.length - 1; i >= 0; i--) {
        var rp = ripples[i];
        rp.r += SETTINGS.animationSpeed;
        rp.opacity -= rp.step;
        if (rp.opacity <= 0) {
          ripples.splice(i, 1);
          continue;
        }
        ctx.beginPath();
        ctx.strokeStyle = 'rgba(' + sr[0] + ',' + sr[1] + ',' + sr[2] + ',' + rp.opacity.toFixed(3) + ')';
        ctx.arc(rp.x, rp.y, rp.r, 0, Math.PI * 2);
        ctx.stroke();
      }
      rafId = ripples.length ? window.requestAnimationFrame(loop) : null;
    }

    function onMove(e) {
      var rect = canvas.getBoundingClientRect();
      addRipple(e.clientX - rect.left, e.clientY - rect.top);
      if (!rafId) rafId = window.requestAnimationFrame(loop);
    }

    function onLeave() {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = null;
      }
      ripples.length = 0;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(resize).observe(section);
    } else {
      window.addEventListener('resize', resize);
    }
    resize();

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave);
  }

  function lazyInit() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;
    if (typeof IntersectionObserver === 'undefined') {
      init(section);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          init(section);
          obs.disconnect();
          return;
        }
      }
    }, { rootMargin: '200px' });
    io.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lazyInit);
  } else {
    lazyInit();
  }
})();
